 import { usePickerhook } from "../../../../hooks/usePickerhook";
 import { useEffect, useState } from "react";
 
   import usePositionHook from "../../../../hooks/usePositionHook";
 
 import useLeaveHook from "../../../../hooks/useLeaveHook";
 import Holiday from "./Holiday";
import Weekend from "./Weekend";

export default () => {
 
  const [showadddept, setshowadddept] = useState(false);
 
   const { OrgLeaveTypes,OrgLeavePolicies, getOrgLeavePolicies, getOrgLeaveTypes } = useLeaveHook();

  const tabs = ["Weekend", "Holiday"];
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const [selectedTab, setselectedTab] = useState(tabs[0]);

  const tabViews =  [<Weekend  />,<Holiday    />];

  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );

  const ActionItem2 = ({ title }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[tabs.indexOf(title)]);
        setselectedTab(title);
      }}
      className={` m-2 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{title}</p>
    </div>
  );

  useEffect(()=>{

    setselectedTabview(tabViews[0]);
    setselectedTab(tabs[0]);
  },[])
  
  return (
    <div className="w-full pr-20  flex  ">
   
    
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="flex  my-3">
          {tabs.map((item) => (
            <ActionItem2 title={item} />
          ))}
        </div>
        <div className="  w-full  flex justify-between items-center  ">
       <p></p>

       
        </div>

     

        {selectedTabview}
      </div>
    </div>
  );
};
